export function initVideoElements() {
    /** @type {NodeListOf<HTMLButtonElement>} */
    const videoButtons = document.querySelectorAll('.c3cookie-video-preview-button');
    for (const videoButton of videoButtons) {
        videoButton.addEventListener('click', () => {
            convertVideoPreview(videoButton, true);
        });

        // automatic remove youtube-video-disclaimer if opt-in accepted
        if (storageIsAccepted('functionality')) {
            convertVideoPreview(videoButton);
        }
    }
}

/**
 * @param {HTMLButtonElement} element
 * @param {boolean} forceAutoplay
 */
function convertVideoPreview(element, forceAutoplay = false) {
    const parentElement = element.parentElement;
    const mainElement = parentElement.parentElement;

    const iframeUrl = new URL(element.dataset.iframeSrc);
    /** @type {Record<string, string>} */
    const attributes = JSON.parse(element.dataset.iframeAttributes);

    const iframe = document.createElement('iframe');

    for (const [key, value] of Object.entries(attributes)) {
        iframe.setAttribute(key, value);
    }

    if (forceAutoplay) {
        iframeUrl.searchParams.set('autoplay', '1');
    }

    iframe.src = iframeUrl.toString();

    mainElement.append(iframe);
    parentElement.remove();
}